import { getCookie } from 'stash/utils/cookies';
import { STASH_INIT } from 'stash/actions/init';
import { getCurrentOrNextParty } from 'stash/actions/api/stockParty';
import type { Middleware } from 'redux';

const stockParty: Middleware = (store) => (next) => (action) => {
	const typedAction = action as { type: string };
	if (typedAction.type === STASH_INIT) {
		const stockPartyCookie = getCookie('stock_party');
		if (stockPartyCookie === 'stock_party') {
			store.dispatch(getCurrentOrNextParty());
		}
	}

	return next(action);
};

export default stockParty;
